import React from 'react';
import Modal from '../shared/Modal';
import FormsySimpleInput from '../form/FormsySimpleInput';
import Formsy from 'formsy-react';
import { menuAPI } from '../../InterfaceAPI/menuAPI';
import { maskMoney } from '../../masks';
import { debounce } from '../../helpers/util';

class DishGroceryCalculatorModal extends React.Component {
  state = {
    servings: 1,
    price: 0,
    ingredients: [],
    isLoading: true
  };

  render() {
    const { handleChange, triggerCalc } = this;
    const { isOpen, closeModal } = this.props;
    const { servings, price } = this.state;

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        onAfterOpen={this.afterOpenModal}
        className="modal modal--wide"
      >
        <div className="modal__head modal__head--flush-bottom">
          <h2 className="h2 modal__heading">Grocery Calculator</h2>
          <Formsy
            className="dish-grocery-list__form"
            onValidSubmit={triggerCalc}
          >
            <div className="cms__bar">
              <div className="cms__bar-item">
                <div className="simple-input__label">Servings</div>
                <FormsySimpleInput
                  type="number"
                  name="servings"
                  placeholder=""
                  className="simple-input simple-input--center dish-grocery-list__input"
                  value={servings}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
              <div className="cms__bar-item">
                <p className="recipe-price__label">
                  Estimated Grocery Cost:{' '}
                  <span className="recipe-price__label--value">
                    {maskMoney(price || '')}
                  </span>
                </p>
              </div>
            </div>
          </Formsy>
        </div>
        <div className="modal__body modal__body--tall">
          <div className="">{this.renderIngredients()}</div>
        </div>
      </Modal>
    );
  }

  renderIngredients() {
    const { ingredients, isLoading } = this.state;
    if (isLoading)
      return (
        <div className="dish__results--empty">
          <p className="p">Loading...</p>
        </div>
      );
    else if (ingredients.length === 0)
      return (
        <div className="dish__results--empty">
          <p className="p">No ingredients.</p>
        </div>
      );
    else
      return (
        <table className="dish-grocery-list">
          <thead>
            <tr>
              <td className="dish-grocery-list__head">Amount / Unit</td>
              <td className="dish-grocery-list__head">Item Name</td>
              <td className="dish-grocery-list__head">Category</td>
              <td className="dish-grocery-list__head">Price</td>
            </tr>
          </thead>
          <tbody className="dish-grocery-list__body">
            {ingredients.length > 0
              ? ingredients
                  .filter(ing => ing.line_amount > 0)
                  .map((ingredient, key) =>
                    this.renderIngredient(ingredient, key)
                  )
              : ''}
          </tbody>
        </table>
      );
  }

  renderIngredient(ingredient, key) {
    const units = this.convertUnit(
      ingredient.quantity,
      ingredient.product.product_format.name
    );
    return (
      <tr key={key} className="dish-grocery-list__row">
        <td className="dish-grocery-list__item">{this.renderUnits(units)}</td>
        <td className="dish-grocery-list__item">{ingredient.name}</td>
        <td className="dish-grocery-list__item">
          {ingredient.product.product_category
            ? ingredient.product.product_category.name
            : '' || ''}
        </td>
        <td className="dish-grocery-list__item">
          {maskMoney(ingredient.line_amount || '')}
        </td>
      </tr>
    );
  }

  convertUnit(quantity, format) {
    if (format !== 'oz') return [{ quantity, format }];
    if (quantity < 16) return [{ quantity, format }];

    const lbs = Math.floor(quantity / 16);
    const ozs = quantity % 16;
    const convertedUnits = [{ quantity: lbs, format: 'lb' }];
    if (ozs > 0) convertedUnits.push({ quantity: ozs, format: 'oz' });

    return convertedUnits;
  }

  renderUnits(units) {
    return units
      .map(({ quantity, format }) => `${quantity} ${format}`)
      .join(', ');
  }

  triggerCalc = () => {
    // start spinner
    this.setState({ ingredients: [], price: 0, isLoading: true });
    this.debouncedUpdatePrice();
  };

  submitCalc = () => {
    const { servings } = this.state;
    if (!servings) {
      this.setState({ isLoading: false });
      return;
    }

    // make request
    menuAPI
      .getDishGroceries({
        components: this.props.components,
        servings: parseFloat(servings)
      })
      .then(({ grocery_list_items: ingredients, total: price }) =>
        this.setState({ ingredients, price, isLoading: false })
      )
      .catch(error => console.log(error));
  };

  debouncedUpdatePrice = debounce(() => this.submitCalc(), 500);

  handleChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.triggerCalc);
  };

  afterOpenModal = () => {
    this.submitCalc();
  };

  // get_lb_from_oz (quantity)
  //   return {0, quantity} if quantity < 16
  //   let pounds = Math.floor(quantity/16);
  //   let oz = quantity % 16;
  //   return {pounds, oz}
  // end
}

export default DishGroceryCalculatorModal;



// WEBPACK FOOTER //
// ./src/components/dish/DishGroceryCalculatorModal.js